import { startBrowserApplication } from '@shared/runtime/browser-config';

void startBrowserApplication('portal', () => import('./renderApp'), import.meta.env.DEV);
